import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo2.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import HomeSharpIcon from '@mui/icons-material/HomeSharp';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import Toggle from "../../Toggle";
import useLocalStorage from "use-local-storage";

function MobileHeader({ handleMobile }) {
    const [isDark, setIsDark] = useLocalStorage("isDark", false);
    const [toggle, setToggle] = useState({
        key: "",
        status: false,
    });
    const handleToggle = (key) => {
        if (toggle.key === key) {
            setToggle({
                status: false,
            });
        } else {
            setToggle({
                status: true,
                key,
            });
        }
    };
    const [activeIndex, setActiveIndex] = useState(null);
    const handleDropdown = (index) => {
        setActiveIndex(index);
    };

    const [scroll, setScroll] = useState(0);

    useEffect(() => {
        document.addEventListener("scroll", () => {
            const scrollCheck = window.scrollY > 100;
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck);
            }
        });
    }, []);
    // ................................................................................

    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigation = (path) => {
        if (location.pathname === path) {
            window.location.reload(); // Force a full page reload
        } else {
            navigate(path);
        }
    };

    return (


        <div className="menu-mobile-popup">
            <div className="modal-menu__backdrop" onClick={handleMobile}></div>
            <div className="widget-filter">
                <div className="mobile-header nonlogin">
                    
                    {isDark ? (
                        <div id="logo" className="logo">
                            <Link to="/Home" onClick={() => handleNavigation("/Home")}>
                                <img
                                    className="site-logo"
                                    id="trans-logo"
                                    src={logo2}
                                    alt="Image"
                                />
                            </Link>
                        </div>
                    ) : (
                        <div id="logo" className="logo">
                            <Link to="/Home" onClick={() => handleNavigation("/Home")}>
                                <img
                                    className="site-logo"
                                    id="trans-logo"
                                    src={logo}
                                    alt="Image"
                                />
                            </Link>
                        </div>
                    )}
                    <Link className="title-button-group close-icon-responsive" onClick={handleMobile}>
                        <i className="icon-close"></i>
                    </Link>
                </div>


                <div className="content-tab">
                    <div className="nav-wrap">
                        <nav className="main-nav mobile">
                            <ul id="menu-primary-menu" className="menu p-0">
                                 
                                <li className="menu-item d-flex align-items-center">
                                    <HomeSharpIcon />
                                    <Link to="/Home" className="ms-2">Home</Link>
                                </li>
                                <li className="menu-item d-flex align-items-center">
                                    <WorkSharpIcon />
                                    <Link to="/Jobs" className="ms-2">Job</Link>
                                </li> 


                            </ul>
                        </nav>
                    </div>
                </div>

                <div className="d-flex mobile-header-login-btn">
                    <div className="khojPrimaryBtn ms-0">
                        <Link to="/Login" className="">Login</Link>
                    </div>
                    <div className="form-group-4 ms-3">
                        <div className="khojSecondaryBtn mobile-not-register-class">
                            <Link to="/Register" className="">Register</Link>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default MobileHeader;
